export { default } from 'common/models/formator-image';
